import { render, staticRenderFns } from "./SweptLoans.vue?vue&type=template&id=46afe866&scoped=true"
import script from "./SweptLoans.vue?vue&type=script&lang=js"
export * from "./SweptLoans.vue?vue&type=script&lang=js"
import style0 from "./SweptLoans.vue?vue&type=style&index=0&id=46afe866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46afe866",
  null
  
)

export default component.exports